import React from 'react';
import styles from './HomeLocationTitleText.module.css';

interface Props {
  text: string;
}

const HomeLocationTitleText: React.FC<Props> = ({ text }: Props) => {
  return <h1 className={styles.text}>{text}</h1>;
};

export default HomeLocationTitleText;
